import React, { useContext, useState } from "react";
import { Button, Modal } from "antd";

import paperShredder from "../../assets/images/webToLead/paper-shredder.svg";
import deleteIcon from "../../assets/images/webToLead/delete.svg";
import { useAlert } from "../../context/AlertProvider";
import { AuthContext } from "../../context/AuthContext";

const DeleteCustomField = ({
  isFormDelete,
  fieldName,
  onDelete,
  isExpired,
  onSubscription,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { isWebToLeadDelete } = useContext(AuthContext);
  const { showAlert } = useAlert();

  const showModal = () => {
    if (isExpired && isFormDelete) {
      onSubscription();
    } else {
      if (isWebToLeadDelete) {
        setIsModalOpen(true);
      } else {
        showAlert(
          "warning",
          "Permission Denied",
          "You do not have permission to delete web to lead form.",
        );
      }
    }
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  return (
    <>
      <div
        className="heading14px d-flex align-items-center"
        style={{
          gap: 8,
          color: "#29292B",
          paddingLeft: 3,
          paddingRight: isFormDelete ? 40 : 0,
        }}
        onClick={showModal}
      >
        <img
          src={deleteIcon}
          alt=""
          width={16}
          height={13}
          className="cursor-pointer"
          style={{ marginBottom: 2 }}
        />
        {isFormDelete && "Delete"}
      </div>
      <Modal
        title={null}
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div className="tw-bg-secondary-color tw-text-text-primary tw-text-lg tw-font-semibold tw-py-4 tw-px-6 tw-rounded-t-2xl">
          Delete {isFormDelete ? fieldName : "Custom Field"}
        </div>
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div
            className="d-flex align-items-center"
            style={{ gap: 50, margin: "0 24px 20px 24px" }}
          >
            <img src={paperShredder} alt="" />
            <div className="text-color-434040 heading16px mt10">
              {isFormDelete ? (
                <>
                  <div>Deleting this link will also delete the form.</div>
                  <div>Are you sure you want to continue?</div>
                </>
              ) : (
                <div>
                  Are you sure you want to delete this {fieldName} Field?
                </div>
              )}
              <div className="mt10">This action can’t be undone.</div>
            </div>
          </div>
        </div>
        <div className="tw-flex tw-bg-secondary-color tw-rounded-b-2xl tw-py-4 tw-px-6 tw-items-center tw-justify-end tw-gap-4">
          <Button
            className="tw-border-sub-text hover:!tw-border-sub-text tw-text-sm tw-text-sub-text hover:!tw-text-sub-text"
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="!tw-bg-theme tw-font-medium !tw-outline-0 !tw-border-theme !tw-text-white tw-font-medium tw-text-sm"
            onClick={() => {
              onDelete();
              handleCancel();
            }}
          >
            Delete
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default DeleteCustomField;
